import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";

import { RegisterYourInterestFacade } from "./facades/register-your-interest.facade";
import {
    REGISTER_YOUR_INTEREST_FEATURE_KEY,
    registerYourInterestReducer,
} from "./reducers/register-your-interest.reducer";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            REGISTER_YOUR_INTEREST_FEATURE_KEY,
            registerYourInterestReducer,
        ),
    ],
    providers: [RegisterYourInterestFacade],
})
export class RegisterYourInterestStateModule {}
